import { render } from "./BovineCalvesTags.vue?vue&type=template&id=240a2aeb&scoped=true"
import script from "./BovineCalvesTags.vue?vue&type=script&lang=js"
export * from "./BovineCalvesTags.vue?vue&type=script&lang=js"

import "./BovineCalvesTags.vue?vue&type=style&index=0&id=240a2aeb&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-240a2aeb"]])

export default __exports__